let apiPrefixUrl = 'https://patient-uat.kfsyscc.org/normal_api/service'

if(process.env.REACT_APP_SERVER === "PRODUCTION"){
    apiPrefixUrl = 'https://patient.kfsyscc.org/normal_api/service'
}


export {
    apiPrefixUrl
}